export default "__VITE_ASSET__CZZGldK7__"